export default __webpack_public_path__ + "static/media/Initiate's Wristbands of the Effulgent Blade.82f8713e.jpg";